import type { Reducer } from "@reduxjs/toolkit"
import { useIsomorphicLayoutEffect, useUnmount } from "react-use"

import { injectReducer, unloadReducer } from "@/3514/store"

function useInjectReducer(name: string, reducer: Reducer, withUnload = false): void {
    useIsomorphicLayoutEffect((): void => {
        injectReducer(name, reducer)
    }, [])

    useUnmount((): void => (withUnload ? unloadReducer(name) : void 0))
}

export { useInjectReducer }
